import React, { createContext, useState } from 'react';
import { createContextHook } from '../contextUtils';

// MapContext manages map visualization states
const MapContext = createContext();

export function MapProvider({ children }) {
  // Data for heat map visualization
  const [heatMapData, setHeatMapData] = useState([]);
  // Data for comparison heat map
  const [comparedHeatMapData, setComparedHeatMapData] = useState([]);
  // Controls range binning for map colors
  const [binRange, setbinRange] = useState(true);
  // Legend items for state map
  const [filterStateMapLegend, setFilterStateMapLegend] = useState([]);
  // Text display for map legends
  const [legendText, setLegendText] = useState([]);
  // J&K state splitting controls for different time periods
  const [splitJK, setSplitJK] = useState(false);
  const [unSplitJKTA, setUnSplitJKTA] = useState(false);
  const [unSplitJK, setUnSplitJK] = useState(false);

  const value = {
    heatMapData, setHeatMapData,
    comparedHeatMapData, setComparedHeatMapData,
    binRange, setbinRange,
    filterStateMapLegend, setFilterStateMapLegend,
    legendText, setLegendText,
    splitJK, setSplitJK,
    unSplitJKTA, setUnSplitJKTA,
    unSplitJK, setUnSplitJK,

  };

  return (
    <MapContext.Provider value={value}>
      {children}
    </MapContext.Provider>
  );
}

export const useMap = createContextHook(MapContext, 'useMap');